// removed by extract-text-webpack-plugin
module.exports = {"react-toggle-switch":"react-toggle-switch","inline-form-field":"inline-form-field"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/ToggleSwitch/ToggleSwitch.scss
// module id = Oz+J
// module chunks = 0